// extracted by mini-css-extract-plugin
module.exports = {"chip":"metric_chip__2Vvpt","problemIcon":"metric_problemIcon__3Jxei","grid":"metric_grid__2DpI4"};